import Vue from 'vue';
import Vuex from 'vuex';
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import axios from 'axios';
import dayjs from 'dayjs';
import zlib from 'zlib';
import download from 'downloadjs';


Vue.use(Vuex)

export default new Vuex.Store({
  strict: false, //in production set to false
    state: {
        address_API: 'https://proyectoperucentre.org:3030/api',
        // address_API: 'http://localhost:3030/api',
        version: 11.00,
        loadingApp: 0,
        loadingAppProgress: false,
        lead: {
            id: null,
            email: '',
            first_name: '',
            last_name: '',
            nationality_id: null,
            gender: null,
            born: null,
            source: null,
            pets_preference: null,
            food_preference: null,
            comments: ''
        },
        applications : [],
        openDialog_sign_in: false,
        showProgressBar: false,
        itemsNationality: [],
        generalSettings: [],
        available_services: [],
        available_options: [],
        available_radioOptions: [],
        available_radioGroups: [],
        available_price_tables: [],
        available_images: [],
        types: [],
        services: [],
        step: '1',
        radioGroups: [],
        options: [],
        loadingUser: false,
        error: null,
        statusLoggedIn: false, 
        displayPets: false,
        pets_preference_set: false,
        displayFood: false,
        food_preference_set: false,
        applicationComments: '',
        uploadInfos: [],
        fileName: undefined,
        progressUpload: 0,
        successMessage: "",
        displaySuccessMessage: Math.random(),
        status: [
            {id: 1, name: 'completed', color: 'ppc_grey'},
            {id: 2, name: 'executing', color: 'ppc_darkgreen'},
            {id: 3, name: 'all set', color: 'ppc_darkgreen'},
            {id: 4, name: 'resource incomplete', color: 'brown'},
            {id: 5, name: 'planning services', color: 'brown'},
            {id: 6, name: 'waiting for dates', color: 'ppc_darkgreen'},
            {id: 7, name: 'waiting for deposit', color: 'ppc_darkgreen'},
            {id: 8, name: 'checking availability', color: 'ppc_pink'},
            {id: 9, name: 'contacting you asap', color: 'ppc_pink'},
            {id: 10, name: 'reviewing upload', color: 'ppc_pink'},
            {id: 11, name: 'waiting for passport', color: 'brown'},
            {id: 12, name: 'waiting for cv', color: 'brown'},
            {id: 13, name: 'payment needed', color: 'red'},
        ],
        appAmount: null,
        addingNewUser: false,
    },
    getters: {
        lead (state) {
            return state.lead
        },
        services (state) {
            return state.services
        },
        servicesLength (state) {
            return state.services.length
        },
        applications (state) {
            return state.applications
        },
        openDialog_sign_in (state) {
            return state.openDialog_sign_in
        },
        showProgressBar (state) {
            return state.showProgressBar
        },
        statusLoggedIn (state) {
            return state.statusLoggedIn
        },
        step (state) {
            return state.step
        },
        loadingUser (state) {
            return state.loadingUser
        },
        loadingApp (state) {
            return state.loadingApp
        },
        loadingAppProgress (state) {
            return state.loadingAppProgress
        },
        error (state) {
            return state.error
        },
        uploadInfos (state) {
            return state.uploadInfos
        },
        progressUpload (state) {
            return state.progressUpload
        },
        successMessage (state) {
            return state.successMessage
        },
        displaySuccessMessage (state) {
            return state.displaySuccessMessage
        },
    },
    /* ############################## */
    mutations: {
        setLoadingApp (state, payload) {
            state.loadingApp = payload
        },
        setLoadingAppProgress (state, payload) {
            state.loadingAppProgress = payload
        },
        SET_LOGGED_IN(state, payload) {
            console.log('SET_LOGGED_IN', payload)
            state.statusLoggedIn = payload;
        },
        signUserOut (state) {
            state.applications = [];
            state.services = [];
            state.radioGroups = [];
            state.options = [];
            state.lead = {
                id: null, 
                email: '', 
                first_name: '', 
                last_name: '', 
                nationality_id: null, 
                gender: null, 
                born: null,
                source: null, 
                pets_preference: null, 
                food_preference: null, 
                comments: '',
                spanishTestDone: null
            };
            state.statusLoggedIn = false;
            state.comments = '';
            state.food_preference_set = false;
            state.pets_preference_set = false;
            state.uploadInfos = [];
        },
        openDialog_sign_in (state, payload) {
            state.openDialog_sign_in = payload;
        },
        showProgressBar (state, payload) {
            state.showProgressBar = payload;
        },
        changeStep (state, payload) {
            state.step = payload;
        },
        setFileName (state, payload) {
            state.fileName = payload
        },
        setLeadAuth (state, payload) {
            state.lead.first_name = payload.first_name;
            state.lead.last_name = payload.last_name;
            state.lead.email = payload.email;
            state.lead.id = payload.id;
            state.statusLoggedIn = true;
            console.log('setLeadAuth', state.lead);
        },
        setAppAmount (state, payload) {
            state.appAmount = payload;
        },
        initAvailableImages (state, payload) {
            state.available_images = payload
        },
        initServices (state, payload) {
            state.services = payload
        },
        initAvailablePriceTables (state, payload) {
            state.available_price_tables = payload
        },
        initApplications (state, payload) {
            state.applications = payload
        },
        initOptions (state, payload) {
            state.options = payload;
        },
        initRadioGroups (state, payload) {
            state.radioGroups = payload
        },
        setLoadingUser (state, payload) {
            state.loadingUser = payload
        },
        setError (state, payload) {
            console.log(payload)
            state.error = payload
        },
        clearError (state) {
            state.error = null
        },
        initNationalities (state, payload) {
            state.itemsNationality = payload
        },
        // setNationality (state) {
        //     state.lead.nationality_set = 1
        // },
        initGeneralSettings (state, payload) {
            state.generalSettings = payload
        },
        initTypes (state, payload) {
            state.types = payload
        },
        initAvailableServices (state, payload) {
            for (let i = 0; i < payload.length; i++) {
                (payload[i].focusAnimals === 0) ? payload[i].focusAnimals = false : payload[i].focusAnimals = true;
                // console.log('initAvailableServices', payload[i].focusAnimals);
                (payload[i].focusChildren === 0) ? payload[i].focusChildren = false : payload[i].focusChildren = true;
                (payload[i].focusMedical === 0) ? payload[i].focusMedical = false : payload[i].focusMedical = true;
            }
            state.available_services = payload;
        },
        initAvailableOptions (state, payload) {
            state.available_options = payload
        },
        initRadioOptions (state, payload) {
            state.available_radioOptions = payload
        },
        initAvailableRadioGroups (state, payload) {
            state.available_radioGroups = payload
        },
        addApplication (state, payload) {
            state.applications.push(
                payload
            );
        },
        addServices (state, payload) {
            state.services.push(
                payload
            );
        },
        changeServicesValue (state, payload) {
            let array = JSON.parse(JSON.stringify(state.services[payload.pos]));
            array[payload.column] = payload.value;
            state.services[payload.pos] = array;
        },
        checkCurrentStatusService (state, service_id) {
            let thisService = state.services.filter(function(select_item) {
                return select_item.id === service_id;
            })
            if (thisService[0].currentStatus !== 1) {
                if (thisService.length > 0) {
                    var uploadMissing = null;
                    var needReview = false;
                    if (thisService[0].requirements.includes('passport')) {
                        let passportUpload = state.uploadInfos.filter(function(select_item) {
                            return select_item.type === 'passport';
                          }
                        )
                        if (passportUpload.length > 0) {
                            if (passportUpload[0].approved === null) {
                                needReview = true;
                            } 
                        } else {
                            uploadMissing = 'passport';
                        }
                    }
                    if (thisService[0].requirements.includes('cv')) {
                        let cvUpload = state.uploadInfos.filter(function(select_item) {
                            return select_item.type === 'cv';
                          }
                        )
                        if (cvUpload.length > 0) {
                            if (cvUpload[0].approved === null) {
                                needReview = true;
                            } 
                        } else {
                            uploadMissing = 'cv';
                        }
                    }
                    if (uploadMissing === 'passport') {
                        thisService[0].currentStatus = 11;
                    } else if (uploadMissing === 'cv') {
                        thisService[0].currentStatus = 12;
                    } else {
                        if (needReview) {
                            thisService[0].currentStatus = 10;
                        } 
                        else {
                            thisService[0].currentStatus = thisService[0].statusAfterReq;
                        }
                    }
                }
            }
            return axios.put(this.state.address_API + '/service_update_pm/', {
                body: thisService[0]
            })
            .then(response => {
                console.log(response)
            })
            .catch(error => {
                console.log(error)
            })
        },
        setServicesApp_nrEmail (state, payload) {
            state.services[payload.pos].lead_id = state.lead.id;
            state.services[payload.pos].application_id = payload.code;
            state.services[payload.pos].comments = payload.comments;
            state.services[payload.pos].currentStatus = state.services[payload.pos].statusAfterReq;
        },
        removeServices (state, payload) {
            state.services = state.services.filter(function(select_item) {
                return select_item.id !== payload;
              }
            )
        },
        changeLeadValue (state, payload) {
            state.lead[payload.column] = payload.value
        },
        changeApplicationComments (state, payload) {
            state.applicationComments = payload
        },
        changeDisplayFood (state, payload) {
            state.displayFood = payload;
        },
        changeDisplayPets (state, payload) {
            state.displayPets = payload;
        },
        addOptions (state, payload) {
            state.options.push(
                payload
            );
        },
        setOptions (state, payload) {
            let i = 0;
            do {
                if (state.options[i].option_id === payload.option_id && state.options[i].services_id === payload.services_id) {
                    state.options[i].selected = payload.event;
                }
                i++;
            }
            while (state.options[i]);
        },
        removeOptions (state, payload) {
            state.options = state.options.filter(function(select_item) {
                return select_item.services_id !== payload;
              }
            )
        },
        addRadios (state, payload) {
            state.radioGroups.push(
                payload
            );
        },
        setRadios (state, payload) {
            let i = 0;
            do {
                if (state.radioGroups[i].radio_group_id === payload.radio_group_id && state.radioGroups[i].services_id === payload.services_id) {
                    state.radioGroups[i].radio_group_value = payload.event;
                }
                i++;
            }
            while (state.radioGroups[i]);
        },
        setGlobalRadios (state, payload) {
            let i = 0;
            do {
                if (state.radioGroups[i].radio_group_id === payload.id) {
                    state.radioGroups[i].radio_group_value = payload.event;
                }
                i++;
            }
            while (state.radioGroups[i]);
        },
        removeRadios (state, payload) {
            state.radioGroups = state.radioGroups.filter(function(select_item) {
                return select_item.services_id !== payload;
              }
            )
        },
        removeDepGlobalRadios (state, payload) {
            state.radioGroups = state.radioGroups.filter(function(select_item) {
                return select_item.radio_group_id !== payload;
              }
            )
        },
        uploadInfos (state, payload) {
            state.uploadInfos = payload;
        },
        progressUpload (state, payload) {
            state.progressUpload = payload;
        },
        successMessage (state, payload) {
            state.successMessage = payload;
            state.displaySuccessMessage = Math.random();
        },
    },
    actions: {
        setLoadingApp (context, payload) {
            context.commit('setLoadingApp', payload);
        },
        setLoadingAppProgress (context, payload) {
            context.commit('setLoadingAppProgress', payload);
        },
        progressUpload (context, payload) {
            context.commit('progressUpload', payload);
        },
        fetchUser({ commit }, user) {
            commit("SET_LOGGED_IN", user !== null);
            if (user) {
                this.dispatch('getLead', user.email)
                console.log('fetchUser test1', user.email)
            }
        },
        async signUserUp ({commit}, payload) {
            this.addingNewUser = true;
            commit('setLoadingUser', true);
            commit('clearError');
            let firstName = payload.first_name.trim();
            let lastName = payload.last_name.trim();
            console.log('signUserUp test1', payload);
            await firebase.auth().createUserWithEmailAndPassword(payload.email, payload.password)
                .then ( async (userCredential) => {
                    console.log('signUserUp test2', userCredential)
                    // Signed in 
                    var user = userCredential.user;
                    console.log('your user has been created')
                    console.log('signUserUp test3', user.email);
                    const date = new Date();
                    const payload = {
                        id: date.getTime(),
                        first_name: firstName,
                        last_name: lastName,
                        email: user.email,
                    };
                    await commit('setLeadAuth', payload);
                    await commit('setLoadingUser', false);
                    await this.dispatch('addLead');
                    this.addingNewUser = false;
                    return;
                })
                .catch((error) => {
                    var errorMessage = error.message;
                    commit('setLoadingUser', false);
                    console.log(errorMessage);
                    commit('setError', error)
                    return;
                });
        },
        signUserIn ({commit}, payload) {
            commit('setLoadingUser', true)
            commit('clearError')
            firebase.auth().signInWithEmailAndPassword(payload.email, payload.password)
                .then( user => {
                    return axios
                    .get(this.state.address_API + '/lead_email_pm/' + user.user.email)
                    .then(result => {
                        console.log(result.data)
                        if (result.data) {
                            console.log('lead found in DB')
                            console.log("you are connected", user)
                            commit('setLoadingUser', false)
                        } else { 
                            console.log('signUserIn test delete')
                            firebase.auth().currentUser.delete();
                            commit("SET_LOGGED_IN", false);
                            commit('errorMessage', 'Email not found. Please Sign In with Google or Sign Up');
                            commit('setLoadingUser', false)
                        }
                    })
                })
                .catch(
                    error => {
                        commit('setLoadingUser', false)
                        commit('setError', error)
                        console.log('error:', error)
                    }
                )
        },
        socialLogin({commit}) {
            this.addingNewUser = true;
            const provider = new firebase.auth.GoogleAuthProvider();
            console.log('socialLogin test1', provider);
            firebase.auth().signInWithPopup(provider).then((user) => {
                console.log("you are connected social login", user)
                return axios
                    .get(this.state.address_API + '/lead_email_pm/' + user.user.email)
                    .then(async result => {
                        console.log('socialLogin test2', result.data)
                        if (result.data) {
                            console.log('lead found in DB');
                            // this.dispatch('getLead', user.user.email)
                        } else {
                            console.log('socialLogin test3');
                            var first_name = null;
                            var last_name = null;
                            if (user.user.displayName.indexOf(' ') > -1) {
                                first_name = user.user.displayName.substring(0, user.user.displayName.indexOf(' '));
                                last_name = user.user.displayName.substring(user.user.displayName.indexOf(' '), user.user.displayName.length);
                            } else {
                                first_name = user.user.displayName;
                            }
                            const date = new Date();
                            const payload = {
                                id: date.getTime(),
                                first_name: first_name,
                                last_name: last_name,
                                email: user.user.email,
                            };
                            await commit('setLeadAuth', payload);
                            await commit('setLoadingUser', false);
                            console.log('socialLogin test4', this.state.lead);
                            await this.dispatch('addLead');
                            this.addingNewUser = false;
                        }
                    })
                    .catch(
                        error => {
                            console.log('error in leads', error)
                        }
                    )
            }).catch(
                error => {
                    commit('setLoadingUser', false)
                    commit('setError', error)
                    console.log('error:', error)
                }
            );
        },
        signUserOut ({commit}) {
            firebase.auth().signOut()
                .then(
                    response => {
                        commit('signUserOut')
                        console.log(response, 'user signed out')
                    }
                )
                .catch(
                    error => {
                        console.log('error:', error)
                    }
                )
        },
        setFileName (context, payload) {
            context.commit('setFileName', payload);
        },
        getAvailableImages (context) {
            return axios.get(this.state.address_API + '/available_images_pm/')
                .then(result => {
                    context.commit('initAvailableImages', result.data);
                })
                .catch(
                    error => {
                        console.log(error);
                        return error.message;
                    }
                )
        },
        async addLead () {
            console.log("create new user", this.state.lead)
            await axios.post(this.state.address_API + '/lead_new_pm/', {
                body: this.state.lead
            })
            .then(response => {
                console.log('addLead to getLead', response);
                this.dispatch('getLead', this.state.lead.email)
            })
            .catch(error => {
                console.log(error.response);
            });
        },
        getLead ({commit}, email) {
            console.log('getLead', email)
            return axios
                .get(this.state.address_API + '/lead_email_pm/' + email)
                .then(result => {
                    console.log('getLead test1', result.data)
                    if (result.data) {
                        (result.data.spanishTestDone) ? result.data.spanishTestDone = dayjs(result.data.spanishTestDone).format("YYYY-MM-DD") : result.data.spanishTestDone = null;
                        (result.data.birthdate) ? result.data.birthdate = dayjs(result.data.birthdate).format("YYYY-MM-DD") : result.data.birthdate = null;
                        result.data.source_id ? result.data.source_id = result.data.source_id.toString() : result.data.source_id = null;
                        if (result.data.food_preference !== null && result.data.food_preference !== "Not known") {
                            this.state.food_preference_set = true;
                        }
                        if (result.data.pets_preference !== null && result.data.pets_preference !== "Not known") {
                            this.state.pets_preference_set = true;
                        }
                        this.state.lead = result.data;
                        this.state.statusLoggedIn = true;
                        //getUploads
                        this.dispatch('getUploads');
                        //get services, options, radiogroups, applications
                        return axios
                            .get(this.state.address_API + '/applications_email_pm/' + email)
                            .then(result => {
                                console.log(result.data, result.data.length)
                                commit('setAppAmount', result.data.length);
                                if (result.data.length > 0) {
                                    console.log(result.data.length, 'applications found');
                                    let i;
                                    for (i = 0; i < result.data.length; i++) {
                                        (result.data[i].applied) ? result.data[i].applied = dayjs(result.data[i].applied).format("YYYY-MM-DD") : result.data[i].applied = null;
                                        (result.data[i].timestamp) ? result.data[i].timestamp = dayjs(result.data[i].timestamp).format("YYYY-MM-DD") : result.data[i].timestamp = null;
                                    }
                                    commit('initApplications', result.data);
                                    return axios
                                        .get(this.state.address_API + '/services_email_pm/' + email)
                                        .then(result => {
                                            console.log(result.data)
                                            if (result.data.length > 0) {
                                                console.log(result.data.length, 'services found', this.state.services.length)
                                                //convert dates
                                                for (i = 0; i < result.data.length; i++) {
                                                    (result.data[i].start) ? result.data[i].start = dayjs(result.data[i].start).format("YYYY-MM-DD") : result.data[i].start = null;
                                                    (result.data[i].end) ? result.data[i].end = dayjs(result.data[i].end).format("YYYY-MM-DD") : result.data[i].end = null;
                                                }
                                                if (this.state.services.length > 0) {
                                                    // user has selected services before login
                                                    let i = 0;
                                                    do {
                                                        result.data.push(
                                                            this.state.services[i]
                                                        );
                                                        i++;
                                                    }
                                                    while (this.state.services[i]);
                                                }
                                                commit('initServices', result.data);
                                                //getRadioGroups
                                                return axios
                                                    .get(this.state.address_API + '/radioGroups_email_pm/' + email)
                                                    .then(result => {
                                                        console.log(result.data)
                                                        if (result.data.length > 0) {
                                                            console.log('radioGroups found', result.data);
                                                            if (this.state.radioGroups.length > 0) {
                                                                let i = 0;
                                                                do {
                                                                    console.log(this.state.radioGroups[i])
                                                                    result.data.push(
                                                                        this.state.radioGroups[i]
                                                                    );
                                                                    i++;
                                                                }
                                                                while (this.state.radioGroups[i]);
                                                            }
                                                            commit('initRadioGroups', result.data);
                                                        } else {
                                                            console.log('No radioGroups found', result.data);
                                                        }
                                                        return axios
                                                            .get(this.state.address_API + '/options_email_pm/' + email)
                                                            .then(result => {
                                                                console.log(result.data)
                                                                if (result.data.length > 0) {
                                                                    console.log('Options found', result.data);
                                                                    if (this.state.options.length > 0) {
                                                                        let i = 0;
                                                                        do {
                                                                            result.data.push(
                                                                                this.state.options[i]
                                                                            );
                                                                            i++;
                                                                        }
                                                                        while (this.state.options[i]);
                                                                    }
                                                                    commit('initOptions', result.data);
                                                                } else {
                                                                    console.log('No Options found', result.data);
                                                                }
                                                            })
                                                            .catch(
                                                                error => {
                                                                    console.log('Options error', error)
                                                                }
                                                            )
                                                    })
                                                    .catch(
                                                        error => {
                                                            console.log('radioGroups error', error)
                                                        }
                                                    )
                                            } else {
                                                console.log('no services found in DB')
                                            }
                                        })
                                        .catch(
                                            error => {
                                                console.log('error in services', error)
                                            }
                                        )
                                } else {
                                    console.log('no applications found in DB')
                                }
                            })
                            .catch(
                                error => {
                                    console.log('error in applications', error)
                                }
                            )
                    } else {
                        console.log('lead not found in DB')
                        if (this.state.statusLoggedIn && !this.addingNewUser) {
                            console.log('getLead test delete')
                            firebase.auth().currentUser.delete();
                            commit("SET_LOGGED_IN", false);
                        }
                        commit('errorMessage', 'Email not found. Please Sign In with Google or Sign Up');
                        commit('setLoadingUser', false);
                    }
                })
                .catch(
                    error => {
                        console.log('error in lead', error)
                    }
                )
        },
        getNationalities (context) {
            return axios
                .get(this.state.address_API + '/nationalities_pm/')
                .then(result => {
                    context.commit('initNationalities', result.data);
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        getGeneralSettings (context) {
            return axios
                .get(this.state.address_API + '/general_settings_pm/')
                .then(result => {
                    context.commit('initGeneralSettings', result.data);
                })
                .catch(
                    error => {
                        console.log(error);
                        return error.message;
                    }
                )
        },
        getTypes (context) {
            return axios
                .get(this.state.address_API + '/types_pm/')
                .then(result => {
                    context.commit('initTypes', result.data);
                })
                .catch(
                    error => {
                        console.log(error);
                        return error.message;
                    }
                )
        },
        getAvailableServices (context) {
            return axios
                .get(this.state.address_API + '/available_services_pm/')
                .then(result => {
                    context.commit('initAvailableServices', result.data);
                })
                .catch(
                    error => {
                        console.log(error);
                        return error.message;
                    }
                )
        },
        getAvailablePriceTables (context) {
            return axios
            .get(this.state.address_API + '/getAvailablePriceTables_pm')
            .then(result => {
                context.commit('initAvailablePriceTables', result.data);
            })
            .catch(
                error => {
                    console.log(error);
                    return error.message;
                }
            )
        },
        getAvailableOptions (context) {
            return axios.get(this.state.address_API + '/available_options_pm/')
                .then(result => {
                    context.commit('initAvailableOptions', result.data);
                })
                .catch(
                    error => {
                        console.log(error);
                        return error.message;
                    }
                )
        },
        getAvailableRadioOptions (context) {
            return axios.get(this.state.address_API + '/available_radioOptions_pm/')
                .then(result => {
                    context.commit('initRadioOptions', result.data);
                })
                .catch(
                    error => {
                        console.log(error);
                        return error.message;
                    }
                )
        },
        getAvailableRadioGroups (context) {
            return axios.get(this.state.address_API + '/available_radioGroups_pm/')
                .then(result => {
                    context.commit('initAvailableRadioGroups', result.data);
                })
                .catch(
                    error => {
                        console.log(error);
                        return error.message;
                    }
                )
        },
        submit (context, totalPrice) {
            const date = new Date();
            let application_id = date.getTime();
            let payload = {
                id: application_id,
                email: this.state.lead.email,
                comments: this.state.applicationComments, 
                totalPrice: totalPrice,
                exchangeRate: this.state.generalSettings[0].currentExchangeRate,
            }
            console.log(payload)
            context.commit('addApplication', payload);
            axios.post(this.state.address_API + '/application_new_pm/', {
                body: payload
            })
            .then(response => {
                console.log(response);
                context.commit('successMessage', 'Application succesfully submitted!')
                context.commit('changeApplicationComments', '');
                if (this.state.services.length > 0) {
                    let i = 0;
                    do {
                        console.log(this.state.services[i])
                        if (!this.state.services[i].application_id) {
                            let ServiceId = this.state.services[i].id;
                            context.commit('setServicesApp_nrEmail', {pos: i, code: application_id});
                            axios.post(this.state.address_API + '/service_new_pm/', {
                                body: this.state.services[i]
                            })
                            .then(data => {
                                context.commit('checkCurrentStatusService', ServiceId);
                                if (this.state.radioGroups.length > 0) {
                                    let j = 0;
                                    do {
                                        let radioGroupId = this.state.radioGroups[j].radio_group_id;
                                        let servicesId = this.state.radioGroups[j].services_id;
                                        if (this.state.radioGroups[j].services_id === JSON.parse(data.config.data).body.id) {
                                            axios.post(this.state.address_API + '/radioGroups_new_pm/', {
                                                body: this.state.radioGroups[j]
                                            })
                                            .then(response => {
                                                console.log(response, this.state.radioGroups[j]);
                                                var radioOptions = this.state.available_radioOptions.filter((select_item) => {
                                                    return select_item.radio_group_id === radioGroupId;
                                                });
                                                for (let index = 0; index < radioOptions.length; index++) {
                                                    radioOptions[index].services_id = servicesId;
                                                    console.log(radioOptions[index]);
                                                    axios.post(this.state.address_API + '/radioOption_new_pm/', {
                                                        body: radioOptions[index]
                                                    })
                                                    .then(response => {
                                                        console.log(response);
                                                    })
                                                    .catch(error => {
                                                        console.log(error);
                                                    });
                                                }
                                            })
                                            .catch(error => {
                                                console.log(error);
                                            });
                                        }
                                        j++;
                                    }
                                    while (this.state.radioGroups[j]);
                                }
                                if (this.state.options.length > 0) {
                                    let j = 0;
                                    do {
                                        if (this.state.options[j].services_id === JSON.parse(data.config.data).body.id) {
                                            axios.post(this.state.address_API + '/options_new_pm/', {
                                                body: this.state.options[j]
                                            })
                                            .then(response => {
                                                console.log(response);
                                            })
                                            .catch(error => {
                                                console.log(error);
                                            });
                                        }
                                        j++;
                                    }
                                    while (this.state.options[j]);
                                }
                                this.dispatch('getUploads')
                                return axios
                                .get(this.state.address_API + '/applications_email_pm/' + this.state.lead.email)
                                .then(result => {
                                    console.log(result.data, result.data.length)
                                    if (result.data.length > 0) {
                                        console.log(result.data.length, 'applications reloaded');
                                        let i;
                                        for (i = 0; i < result.data.length; i++) {
                                            (result.data[i].applied) ? result.data[i].applied = dayjs(result.data[i].applied).format("YYYY-MM-DD") : result.data[i].applied = null;
                                            (result.data[i].timestamp) ? result.data[i].timestamp = dayjs(result.data[i].timestamp).format("YYYY-MM-DD") : result.data[i].timestamp = null;
                                        }
                                        context.commit('initApplications', result.data);
                                    }
                                })
                            })
                            .catch(error => {
                                console.log(error);
                            });
                        }
                        i++;
                    }
                    while (this.state.services[i]);
                }
            })
        },
        addServices (context, payload) {
            context.commit('addServices', payload)
        },
        changeServicesValue (context, payload) {
            context.commit('changeServicesValue', payload);
            context.commit('checkCurrentStatusService', this.state.services[payload.pos].id);
        },
        removeServices (context, payload) {
            context.commit('removeServices', payload)
        },
        addOptions (context, payload) {
            context.commit('addOptions', payload)
        },
        setOptions (context, payload) {
            context.commit('setOptions', payload)
        },
        removeOptions (context, payload) {
            context.commit('removeOptions', payload)
        },
        addRadios (context, payload) {
            context.commit('addRadios', payload)
        },
        setRadios (context, payload) {
            context.commit('setRadios', payload)
        },
        setGlobalRadios (context, payload) {
            context.commit('setGlobalRadios', payload)
        },
        removeRadios (context, payload) {
            context.commit('removeRadios', payload)
        },
        removeDepGlobalRadios (context, payload) {
            context.commit('removeDepGlobalRadios', payload)
        },
        changeLeadValue (context, payload) {
            context.commit('changeLeadValue', payload)
            console.log('changeLeadValue', this.state.lead)
            return axios
            .put(this.state.address_API + '/lead_update_pm/', {
                body: this.state.lead
            })
            .then(response => {
                console.log(response);
                return response.statusText;
            })
            .catch(
                error => {
                    console.log(error);
                    return error.message;
                }
            )
        },
        changeApplicationComments (context, payload) {
            context.commit('changeApplicationComments', payload)
        },
        changeDisplayPets (context, payload) {
            context.commit('changeDisplayPets', payload)
        },
        changeDisplayFood (context, payload) {
            context.commit('changeDisplayFood', payload)
        },
        clearError (context) {
            context.commit('clearError')
        },
        openDialog_sign_in (context, payload) {
            context.commit('openDialog_sign_in', payload)
        },
        showProgressBar (context, payload) {
            context.commit('showProgressBar', payload)
        },
        changeStep (context, payload) {
            context.commit('changeStep', payload)
        },
        successMessage (context, payload) {
            context.commit('successMessage', payload)
        },
        getUploads (context) {
            return axios
                .get(this.state.address_API + '/getUploads_pm/' + this.state.lead.id)
                .then(result => {
                    context.commit('uploadInfos', result.data);
                    let i;
                    for (i = 0; i < this.state.services.length; i++) {
                        context.commit('checkCurrentStatusService', this.state.services[i].id);
                    }
                })
                .catch(
                    error => {
                        console.log(error)
                    }
                )
        },
        addUpload (context, payload) {
            payload.name = this.state.fileName;
            payload.approved = null;
            context.commit('progressUpload', 0);
            var config = {
                onUploadProgress: function(progressEvent) {
                    var percentCompleted = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
                    context.commit('progressUpload', percentCompleted);
                }
            };
            axios.post(this.state.address_API + '/upload_new_pm/', payload, config)
            .then(response => {
                console.log(response);
                this.dispatch('getUploads');
                context.commit('successMessage', 'Document successfully uploaded!');
                context.commit('showProgressBar', false);
                context.commit('progressUpload', 0);
            })
            .catch(error => {
                console.log(error);
            });
        },
        downloadFile (context, payload) {
            console.log(payload)
            return axios
                .get(this.state.address_API + '/getUpload_id_pm/' + payload)
                .then(result => {
                    if (result.data) {
                        console.log(result.data.name)
                        const zip = result.data.file
                        const originalObj = JSON.parse(zlib.unzipSync(Buffer.from(zip, 'base64')));
                        download(originalObj, result.data.name)
                    }
                })
                .catch(error => {
                    console.log(error);
                });
        },
        deleteFile (context, payload) {
            console.log(payload)
            return axios
                .delete(this.state.address_API + '/deleteUpload_id_pm/' + payload)
                .then(result => {
                    console.log(result)
                    this.dispatch('getUploads')
                    context.commit('successMessage', 'Document successfully removed!')
                })
                .catch(error => {
                    console.log(error);
                });
        },
    }
})